import { Component } from 'react'
import Table2 from 'components/molecules/tables/Table2'

class TransactionsHeader extends Component {
  render () {
    return (
      <Table2.HeadRow>
        <Table2.HeadCell name='date' sorting>
          Date
        </Table2.HeadCell>
        <Table2.HeadCell name='description' sorting>
          Description
        </Table2.HeadCell>
        <Table2.HeadCell name='account__name' sorting>
          Account
        </Table2.HeadCell>
        <Table2.HeadCell name='category' sorting>
          Category
        </Table2.HeadCell>
        <Table2.HeadCell name='amount' sorting>
          Amount
        </Table2.HeadCell>
        <Table2.HeadCell name='edit' />
      </Table2.HeadRow>
    )
  }
}

export default TransactionsHeader
